// libs
import React from 'react';
import format from 'date-fns/format';
import isEqual from 'date-fns/isEqual';
import toDate from 'date-fns/toDate';

import { cn } from '@lyearn/style';
// components
import { DatePickerDate, PickersDay, PickersDayProps } from '@lyearn/ui';

// styles

interface CalendarDayProps {
  selectedDate: Date | null;
  daysWithActivity: Set<string>;
  pickersDayProps: PickersDayProps<DatePickerDate>;
}

function CalendarDay({ selectedDate, daysWithActivity, pickersDayProps }: CalendarDayProps) {
  const selectedDateCopy = selectedDate ? toDate(selectedDate).setHours(0, 0, 0, 0) : -1;
  const dayCopy = toDate(pickersDayProps.day!).setHours(0, 0, 0, 0);
  const isSameDate = selectedDate ? isEqual(selectedDateCopy, dayCopy) : false;
  const highlightDate = daysWithActivity.has(format(dayCopy, 'yyyy-MM-dd')) && !isSameDate;

  return (
    <PickersDay
      {...pickersDayProps}
      className={cn({
        'border border-solid border-interactive-secondary-hover': highlightDate,
      })}
    />
  );
}

export default React.memo(CalendarDay);
